function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import useMergeState from '@restart/hooks/useMergeState';
import useMounted from '@restart/hooks/useMounted';
import React, { useRef } from 'react';
import Dialog from './Dialog';
import DialogContext from './DialogContext';
export default function DialogProvider({
  children
}) {
  const isMounted = useMounted();
  const [{
    revision,
    show,
    dialogProps
  }, setState] = useMergeState({
    revision: 0,
    show: false,
    dialogProps: null
  });
  const deferredRef = useRef({});

  function open(content, nextProps) {
    if (show) {
      throw new Error('Dialog already opened!');
    }

    return new Promise(resolve => {
      if (!isMounted()) {
        resolve(false);
        return;
      }

      deferredRef.current.resolve = resolve;
      setState(prevState => ({
        show: true,
        revision: prevState.revision + 1,
        dialogProps: { ...nextProps,
          children: content,
          onCancel: () => {
            if (isMounted()) setState({
              show: false
            });
            resolve(false);
          },

          onConfirmed(data) {
            if (isMounted()) setState({
              show: false
            });
            resolve(data);
          }

        }
      }));
    });
  }

  const context = Object.assign(useRef({}).current, {
    open,

    close() {
      if (!show) {
        throw new Error('Dialog already closed!');
      }

      if (isMounted()) setState({
        show: false
      });
      deferredRef.current.resolve(false);
    }

  });
  return React.createElement(DialogContext.Provider, {
    value: context
  }, children, dialogProps ? React.createElement(Dialog, _extends({
    key: revision
  }, dialogProps, {
    show: show
  })) : null);
}